import { MultiFilter } from '@pages/Clients/NewClientsList/components';
import { CLIENT_ROWS } from '@pages/Clients/NewClientsList/data/rows';

import type { FC } from 'react';

export const ClientVisit: FC<{ id: number; onClear: (id: number) => void }> = ({
  id,
  onClear,
}) => {
  return (
    <MultiFilter
      label="По клиентам"
      selectedCount={0}
      rows={CLIENT_ROWS}
      width={250}
      id={id}
      onClear={onClear}
    />
  );
};
